import React from 'react';
interface FloatingMetalButtonProps {
  emoji: string;
  className?: string;
  style?: React.CSSProperties;
}
export const FloatingMetalButton: React.FC<FloatingMetalButtonProps> = ({
  emoji,
  className = '',
  style
}) => {
  return <div className={`floating-metal ${className}`} style={style} data-id="element-180">
      <div className="metal-outline" data-id="element-181">
        <div className="metal-inner" data-id="element-182">{emoji}</div>
      </div>
    </div>;
};